export default "__VITE_ASSET__2cw3u71a__"